import throttle from 'lodash/throttle'

export default {
  init: () => {
    const scrollToTop = document.querySelector('.scroll-to-top')

    if (scrollToTop) {
      window.addEventListener(
        'scroll',
        throttle(() => {
          const offset =
            (document.documentElement.scrollTop + document.body.scrollTop) /
            (document.documentElement.scrollHeight - document.documentElement.clientHeight)

          if (offset > 0.5) {
            scrollToTop.classList.add('is-active')
          } else {
            scrollToTop.classList.remove('is-active')
          }
        })
      )
    }
  },
}
